<div *ngIf="centerDetail && theme" class="container-fluid px-0">
    <div class="header-content">
        <div class="picsum-img-wrapper mb-3">
            <img [src]="centerDetail.IMAGE_BANNER_URL" class="bannerWidth centerImg" [alt]="centerDetail.IMAGE_BANNER">
        </div>

        <div class="description-profile">
            <div class="container">
                <div class="row d-flex desProfile-wrapper">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-12 mb-3">
                        <div class="card center-description">
                            <div class="wrapper p-lg-4 p-md-3 p-sm-3 p-3">
                                <p class="text-header">
                                    {{ centerDetail.CENTER_NAME }}
                                </p>
                                <div class="description-box">
                                    <div class="text-description px-2">
                                        {{ centerDetail.CENTER_DESCRIPTION }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12 mb-3">
                        <div class="center-profile-img">
                            <img [src]="centerDetail.IMAGE_PROFILE_URL" class="profile-img img-fluid"
                                [alt]="centerDetail.IMAGE_PROFILE">
                        </div>
                    </div>
                </div>
            </div>

            <div class="container pt-3">
                <div class="content2 p-3" [innerHTML]="content2"
                    [ngStyle]="{'background': theme.CONTENT2_BG, 'box-shadow': theme.CONTENT2_BG_SD}">
                </div>
            </div>

            <div *ngIf="content2_arr.length > 0" class="container py-3">
                <div class="row d-flex justify-content-center">
                    <div *ngFor="let content of content2_arr" class="col-lg-6 col-md-6 col-sm-12 col-12 my-3">
                        <div class="content3 p-3"
                            [ngStyle]="{'background': theme.CONTENT3_BG, 'box-shadow': theme.CONTENT3_BG_SD}">
                            <div class="row d-flex mb-3">
                                <div class="col-2">
                                    <div class="profile">
                                        <img [src]="content.CONTENT3_IMAGE_URL" class="profile-img img-fluid"
                                        [alt]="content.CONTENT3_IMAGE_PROFILE">
                                    </div>
                                </div>
                                <div class="col-10 content3-header d-flex">
                                    <p class="text-left text-header mx-2 my-auto"
                                        [ngStyle]="{'color': theme.CONTENT3_TL_TX_CL}">
                                        {{ content.CONTENT3_TITLE }}
                                    </p>
                                </div>
                            </div>
                            <div class="content3-detail">
                                <p class="text-left text-detail px-3" [innerHtml]="content.CONTENT3_DETAIL">
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="content3_videos.length > 0" class="container py-5">
                <!-- <div class="row d-flex justify-content-center">
                    <div *ngFor="let b of content3_videos" class="col-lg-4 col-md-6 col-sm-12 col-12 pb-3">
                        <div class="embed-responsive embed-responsive-16by9 vdo-frame">
                            <iframe id="vdoFrame" class="embed-responsive-item" [src]="b.VIDEO_URL" frameborder="0"
                                allow="autoplay; fullscreen" allowfullscreen></iframe>
                        </div>
                    </div>
                </div> -->
                <swiper [config]="videoConfig" class="swiper-container">
                    <ng-template swiperSlide *ngFor="let b of content3_videos">
                        <div class="embed-responsive embed-responsive-16by9 vdo-frame">
                            <iframe id="vdoFrame" class="embed-responsive-item" [src]="b.VIDEO_URL" frameborder="0"
                                allow="autoplay; fullscreen" allowfullscreen></iframe>
                        </div>
                    </ng-template>
                </swiper>
            </div>

            <div class="container my-4 mb-2">
                <div class="d-flex">
                    <p class="text-left research-header">
                        <span>งานวิจัยที่เกี่ยวข้อง</span>
                    </p>
                </div>

                <p class="my-3" [innerHtml]="researchText"></p>
            </div>
        </div>
    </div>

</div>